import { createContext } from 'react'

interface DateSelectionContextValue {
  selectedFrom: Date | null
  selectedTo: Date | null
  setSelectedFrom: (date: Date | null) => void
  setSelectedTo: (date: Date | null) => void
}

export const DateSelectionContext = createContext<DateSelectionContextValue | null>(null)
